import { WorkoutType } from 'fitbeat.models';
import React, { FunctionComponent } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import Theme from '../../theme';
import { getWorkoutDuration, getWorkoutDurationDescription } from '../../utils';
import { defaultScale } from '../../utils/scaling';
import { ButtonMargin, SelectionContainer } from './SelectionContainer';

interface IProps {
  workoutType: WorkoutType;
  onPress(workoutType: WorkoutType): void;
}

export const ClassDurationSelection: FunctionComponent<IProps> = ({ onPress, workoutType }) => {
  return (
    <View style={styles.container}>
      <ClassDuration
        style={{ marginRight: defaultScale(ButtonMargin) }}
        onPress={onPress}
        currentWorkoutType={workoutType}
        workoutType={WorkoutType.QuickHomeOrStaticCardioWorkout}
      />
      <ClassDuration
        onPress={onPress}
        currentWorkoutType={workoutType}
        workoutType={WorkoutType.MediumHomeOrStaticCardioWorkout}
      />
      <ClassDuration
        onPress={onPress}
        style={{ marginLeft: defaultScale(ButtonMargin) }}
        currentWorkoutType={workoutType}
        workoutType={WorkoutType.FullHomeOrStaticCardioWorkout}
      />
    </View>
  );
};

const ClassDuration = ({ currentWorkoutType, workoutType, onPress, style = {} }) => {
  const isSelected = currentWorkoutType === workoutType;
  return (
    <SelectionContainer
      width={defaultScale(110)}
      height={defaultScale(140)}
      title={getWorkoutDuration[workoutType]}
      isSelected={isSelected}
      style={style}
      onPress={() => onPress(workoutType)}
      icon={(
        <Text style={[styles.durationDescription, {
          color: isSelected ? Theme.WHITE : Theme.CHARCOAL,
        }]}>
          {getWorkoutDurationDescription[workoutType]}
        </Text>
      )}
    />
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'center',
  },
  durationDescription: {
    ...Theme.textStyle.heading,
    paddingTop: defaultScale(10),
    textAlign: 'center',
  },
});
